import {
  addDays,
  endOfDay,
  startOfDay,
  startOfMonth,
  endOfMonth,
  addMonths,
  startOfWeek,
  endOfWeek,
  isSameDay,
} from 'date-fns'

export const defineds = {
  startOfWeek: startOfWeek(new Date()),
  endOfWeek: endOfWeek(new Date()),
  startOfLastWeek: startOfWeek(addDays(new Date(), -7)),
  endOfLastWeek: endOfWeek(addDays(new Date(), -7)),
  startOfToday: startOfDay(new Date()),
  endOfToday: endOfDay(new Date()),
  startOfYesterday: startOfDay(addDays(new Date(), -1)),
  endOfYesterday: endOfDay(addDays(new Date(), -1)),
  startOfMonth: startOfMonth(new Date()),
  endOfMonth: endOfMonth(new Date()),
  startOfLastMonth: startOfMonth(addMonths(new Date(), -1)),
  endOfLastMonth: endOfMonth(addMonths(new Date(), -1)),
  last7Days: startOfDay(addDays(new Date(), -7)),
  last30Days: startOfDay(addDays(new Date(), -30)),
  last90Days: startOfDay(addDays(new Date(), -90)),
  last180Days: startOfDay(addDays(new Date(), -180)),
  lastYear: startOfDay(addDays(new Date(), -365)),
}

const staticRangeHandler = {
  range: {},
  isSelected(range) {
    const definedRange = this.range()
    return (
      isSameDay(range.startDate, definedRange.startDate) &&
      isSameDay(range.endDate, definedRange.endDate)
    )
  },
}

export function createStaticRanges(ranges) {
  return ranges.map(range => ({ ...staticRangeHandler, ...range }))
}

export const defaultStaticRanges = createStaticRanges([
  // {
  //   label: 'Hoje',
  //   range: () => ({
  //     startDate: defineds.startOfToday,
  //     endDate: defineds.endOfToday,
  //   }),
  // },
  // {
  //   label: 'Ontem',
  //   range: () => ({
  //     startDate: defineds.startOfYesterday,
  //     endDate: defineds.endOfYesterday,
  //   }),
  // },
  {
    label: 'Esta semana',
    range: () => ({
      startDate: defineds.startOfWeek,
      endDate: defineds.endOfWeek,
    }),
  },
  {
    label: 'Últimos 7 dias',
    range: () => ({
      startDate: defineds.last7Days,
      endDate: defineds.endOfToday,
    }),
  },
  // {
  //   label: 'Semana passada',
  //   range: () => ({
  //     startDate: defineds.startOfLastWeek,
  //     endDate: defineds.endOfLastWeek,
  //   }),
  // },
  {
    label: 'Este Mês',
    range: () => ({
      startDate: defineds.startOfMonth,
      endDate: defineds.endOfMonth,
    }),
  },
  {
    label: 'Últimos 30 dias',
    range: () => ({
      startDate: defineds.last30Days,
      endDate: defineds.endOfToday,
    }),
  },
  {
    label: 'Mês Passado',
    range: () => ({
      startDate: defineds.startOfLastMonth,
      endDate: defineds.endOfLastMonth,
    }),
  },
])

export const monthStaticRanges = createStaticRanges([
  {
    label: 'Este Mês',
    range: () => ({
      startDate: defineds.startOfMonth,
      endDate: defineds.endOfMonth,
    }),
  },
  {
    label: 'Últimos 30 dias',
    range: () => ({
      startDate: defineds.last30Days,
      endDate: defineds.endOfToday,
    }),
  },
  {
    label: 'Últimos 3 meses',
    range: () => ({
      startDate: defineds.last90Days,
      endDate: defineds.endOfToday,
    }),
  },
  {
    label: 'Últimos 6 meses',
    range: () => ({
      startDate: defineds.last180Days,
      endDate: defineds.endOfToday,
    }),
  },
  {
    label: 'Últimos 12 meses',
    range: () => ({
      startDate: defineds.lastYear,
      endDate: defineds.endOfToday,
    }),
  },
])
